/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type IntegrationClientResponse = {
    id: number;
    firstName: string;
    lastName: string;
    gender: IntegrationClientResponse.gender;
    email: string | null;
    phoneNumber: string | null;
    isActive: boolean;
    archived: boolean;
    hasAccount: boolean;
};
export namespace IntegrationClientResponse {
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        DIVERSE = 'diverse',
        NOT_SET = 'not_set',
        DELETED = 'deleted',
    }
}

